import type { IconSvgObject } from './types';

const Hexagon01Icon: IconSvgObject = [
  ["path", { d: "M20.4857 6.71425L12.4857 2.2698C12.1837 2.10201 11.8165 2.10201 11.5144 2.2698L3.51436 6.71424C3.19689 6.89061 3 7.22524 3 7.58841L3.00008 16.4116C3.00009 16.7748 3.19698 17.1094 3.51444 17.2858L11.5144 21.7302C11.8165 21.898 12.1837 21.898 12.4857 21.7302L20.4857 17.2858C20.8031 17.1094 21 16.7748 21 16.4116V7.5884C21 7.22524 20.8031 6.89062 20.4857 6.71425Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Hexagon01Icon;
